var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.63 533.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".microsoft_svg__d{fill:#00adef}.microsoft_svg__e{fill:#f1511b}.microsoft_svg__f{fill:#fbbc09}.microsoft_svg__g{fill:#80cc28}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__e",
    d: "M253.61,253.61H0V0H253.61V253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__g",
    d: "M533.63,253.61h-253.61V0h253.61V253.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__d",
    d: "M253.6,533.73H0v-253.61H253.6v253.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "microsoft_svg__f",
    d: "M533.63,533.73h-253.61v-253.61h253.61v253.61h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.a87891f6316f633abbf4641ccd88dea9.svg";
export { ForwardRef as ReactComponent };